module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('h1', {
    staticClass: "tochead"
  }, [_vm._v("Contents")])]), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Maps_Images"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Master Maps")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Abbreviations"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("Chapter 1:")]), _vm._v(" The British Attack at Cambrai (Master Maps 3 & 4)")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chapt"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_1#sec1"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Tank Attack")])])])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_1#sec295"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("295.")]), _vm._v(" Rfn Albert Shepherd, 12 King’s Royal Rifle Corps, 20 November 1917, Villers-Plouich, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_1#sec296"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("296.")]), _vm._v(" Capt Richard Wain, A Battalion, Tank Corps, 20 November 1917, Marcoing, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_1#sec297"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("297.")]), _vm._v(" LCpl Robert McBeath, 1/5 Seaforth Highlanders, 20 November 1917, Ribécourt, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_1#sec298"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("298.")]), _vm._v(" Lt Col John Sherwood-Kelly, Norfolk Regiment att’d 1 Royal Inniskilling Fusiliers, 20 November 1917, Marcoing, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_1#sec299"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("299.")]), _vm._v(" Sgt Charles Spackman, 1 Border, 20 November 1917, Marcoing, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_1#sec300"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("300.")]), _vm._v(" Lt Harcus Strachan, Fort Garry Horse, CEF, 20 November 1917, Masnieres, France")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chapt"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_1#sec2"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Capture of Bourlon Wood")])])])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_1#sec301"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("301.")]), _vm._v(" Sgt John McAulay 1 Scots Guards, 27 November 1917, Fontaine-Notre-Dame, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_1#sec302"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("302.")]), _vm._v(" Pte George Clare, 5 Lancers, 28 November 1917, Bourlon Wood, France")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter_2"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("Chapter 2:")]), _vm._v(" The German Counterattack at Cambrai (Master Maps 3 & 4)")])])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter_2#sec303"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("303.")]), _vm._v(" Sgt Cyril Gourley, D/276 Brigade RFA, 30 November 1917, East of Épehy, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter_2#sec304"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("304.")]), _vm._v(" Lt Col Neville Elliott-Cooper, 8 Royal Fusiliers, 30 November 1917, East of la Vacquerie, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter_2#sec305"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("305.")]), _vm._v(" Lt Samuel Wallace, C/63 Brigade RFA, 30 November 1917, Gonnelieu, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter_2#sec306"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("306.")]), _vm._v(" Capt Robert Gee, 2 Royal Fusiliers, 30 November 1917, Masnières, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter_2#sec307"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("307.")]), _vm._v(" LCpl John Thomas, 2/5 North Staffordshire, 30 November 1917, Fontaine-Notre-Dame, France")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter_2#sec308"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("308.")]), _vm._v(" Capt Walter Stone, 17 Royal Fusiliers, 30 November 1917, Moeuvres, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter_2#sec309"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("309.")]), _vm._v(" Capt Allastair McReady-Diarmid, 17 Middlesex, 30 November–1 December 1917, Moeuvres, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter_2#sec310"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("310.")]), _vm._v(" L/Dafadar Gobind Singh, 28 Light Cavalry, att’d 2 Lancers (Gardner’s Horse), 1 December 1917, East of Épehy, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter_2#sec311"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("311.")]), _vm._v(" Capt George Paton, 4 Grenadier Guards, 1 December 1917, Gonnelieu, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter_2#sec312"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("312.")]), _vm._v(" Capt Arthur Lascelles, 14 Durham Light Infantry, 3 December 1917, Masnières, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter_2#sec314"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("314.")]), _vm._v(" 2Lt James Emerson, 9 Royal Inniskilling Fusiliers, 6 December 1917, North of la Vacquerie, France")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("Chapter 3:")]), _vm._v(" Local Operations Winter 1917–18 (Master Maps 1 & 2)")])])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_3#sec313",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("313.")]), _vm._v(" Pte Henry Nicholas, 1 Canterbury NZEF, 3 December 1917, Polderhoek, Belgium")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_3#sec315",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("315.")]), _vm._v(" Pte Walter Mills, 1/10 Manchester, 10–11 December 1917, Givenchy, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_3#sec316",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("316.")]), _vm._v(" LCpl Charles Robertson, 10 Royal Fusiliers, 8/9 March 1918, West of Polderhoek Chateau, Belgium")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("Chapter 4:")]), _vm._v(" First Battles of the Somme 1918 – Battle of St Quentin (Master Maps 3, 5, 6 & 7)")])])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_4#sec317",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("317.")]), _vm._v(" Gnr Charles Stone, C/83 Brigade RFA, 21 March 1918, Benay, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_4#sec318",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("318.")]), _vm._v(" 2Lt Edmund De Wind, 15 Royal Irish Rifles, 21 March 1918, Grougies, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_4#sec319",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("319.")]), _vm._v(" Lt Col Wilfrith Elstob, 16 Manchester, 21 March 1918, Francilly-Selency, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_4#sec320",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("320.")]), _vm._v(" 2Lt John Buchan, 8 Argyll & Sutherland Highlanders, 21 March 1918, East of Marteville, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_4#sec321",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("321.")]), _vm._v(" Lt Allan Ker, Gordon Highlanders att’d 61 MGC, 21 March 1918, Near St Quentin, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_4#sec322",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("322.")]), _vm._v(" LCpl John Sayer, 8 Queen’s (Royal West Surrey), 21 March 1918, Le Verguier, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_4#sec323",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("323.")]), _vm._v(" Capt Manley James, 8 Gloucestershire, 21 March 1918, Doignies & Velu Wood, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_4a#sec324",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("324.")]), _vm._v(" 2Lt Alfred Herring, ASC att’d 6 Northamptonshire, 22 March 1918, Montagne Bridge, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_4a#sec325",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("325.")]), _vm._v(" 2Lt Cecil Knox, 150 Field Company RE, 22 March 1918, Tugny, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_4a#sec326",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("326.")]), _vm._v(" Pte Herbert Columbine, 9 Squadron, Machine Gun Corps, 22 March 1918, Hervilly Wood, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_4a#sec327",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("327.")]), _vm._v(" Sgt Harold Jackson, 7 East Yorkshire, 22 March 1918, Hermies, France")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_4a#sec328",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("328.")]), _vm._v(" Capt Reginald Hayward, 1 Wiltshire, 22 March 1918, Near Fremicourt, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_4a#sec329",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("329.")]), _vm._v(" 2Lt Ernest Beal, 13 Green Howards, 22 March 1918, St Leger, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_4a#sec330",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("330.")]), _vm._v(" Capt Christopher Bushell, 7 Queen’s (Royal West Surrey), 23 March 1918, West of St Quentin Canal, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_4a#sec331",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("331.")]), _vm._v(" Lt Col Frank Roberts, 1 Worcestershire, 23 March 1918, Pargny, France")])]), _vm._v(" "), _c('h4', {
    staticClass: "num_list1k"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_4a#sec332",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("332.")]), _vm._v(" Capt Julian Gribble, 10 Royal Warwickshire, 23 March 1918, Beaumetz, France")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chapt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Biographies",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Biographies")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Sources",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sources")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Useful_Information",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Useful Information")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0